// This utility helps with the somewhat common case where our query string parameters all need a given prefix
export default function prefixObjectKeys<O>(obj: O, prefix: string): { [key: string]: any } {
  // @ts-ignore - TODO
  return Object.entries(obj).reduce((collector, [key, value]) => {
    collector[prefix + key] = value ?? undefined
    return collector
  }, {} as any)
}
